import Api from "./Api";
import { createQueryString } from "./ApiHelper";

function getAssignedCinemaIds() {
  const userData = JSON.parse(localStorage.getItem("userData") || "null");
  const cinemaId = userData && (userData.cinemaId || userData.cinema_id);

  if (cinemaId === null || cinemaId === undefined || cinemaId === "") {
    return [];
  }

  return String(cinemaId)
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
}

function filterCinemas(records) {
  const assignedCinemaIds = getAssignedCinemaIds();
  if (assignedCinemaIds.length === 0) {
    return records;
  }

  return records.filter((cinema) =>
    assignedCinemaIds.includes(String(cinema.cine_id))
  );
}

export default {
  GetGlobalOptions(payload) {
    if (payload) {
      const query = createQueryString(payload);
      return Api().get(
        `/api/v3/external/sales-analytics/global-options${query}`
      );
    } else {
      return Api().get(`/api/v3/external/sales-analytics/global-options`);
    }
  },

  GetCinemas(payload = {}) {
    payload.cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    return Api()
      .post(`/api/v3/external/sales-analytics/getcinemas`, payload)
      .then((response) => {
        if (response.data && Array.isArray(response.data.Records)) {
          const records = response.data.Records;
          const assignedCinemaIds = getAssignedCinemaIds();
          response.data.allCinemaAccess =
            assignedCinemaIds.length === 0 ||
            (assignedCinemaIds.length >= records.length &&
              records.every((cinema) =>
                assignedCinemaIds.includes(String(cinema.cine_id))
              ));
          response.data.Records = filterCinemas(records);
        }
        return response;
      });
  },
};



// WEBPACK FOOTER //
// ./src/services/MasterService.js